import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import { OrganizationSchema, WebSiteSchema, WebPageSchema } from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import LatestVideos from './components/LatestVideos';
import Features from './components/Features';
import HotVideos from './components/HotVideos';
import PlatformSection from './components/PlatformSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="嫩草视频 - 妖精视频桃花视频热播新剧完整版高清在线观看 | 苹果视频榴莲视频豆花视频电影全集"
        description="嫩草视频聚合妖精视频、桃花视频、苹果视频、榴莲视频等平台热播影视剧，最新电视剧完整版高清在线观看，电影大全每日更新，追剧不等待。"
        keywords="嫩草视频,妖精视频,桃花视频,热播剧,完整版,苹果视频,榴莲视频,高清在线观看,新剧,电影全集"
        canonicalUrl="https://www.nencao.com"
      />
      <OrganizationSchema />
      <WebSiteSchema />
      <WebPageSchema
        title="嫩草视频 - 妖精视频桃花视频热播新剧完整版高清在线观看"
        description="嫩草视频聚合妖精视频、桃花视频、苹果视频、榴莲视频等平台热播影视剧，最新电视剧完整版高清在线观看。"
        url="https://www.nencao.com"
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategorySection />
          <LatestVideos />
          <Features />
          <HotVideos />
          <PlatformSection />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}